module.exports = __webpack_public_path__ + "img/Where-To-Next.3fbce5bc.png";